import { raundColors } from '@/theme/colors'
import { Switch as MantineSwitch } from '@mantine/core'
import type React from 'react'
import styles from './Switch.module.css'

// ─────────────────────────────────────────────
// 型定義
// ─────────────────────────────────────────────
export type SwitchProps = {
  checked?: boolean
  defaultChecked?: boolean
  onChange?: (checked: boolean) => void
  disabled?: boolean
  label?: string
  /** ON 状態のトラック色。CSS 変数（例: `var(--main-color)`）も指定可能。デフォルト: `raundColors.primary.base` */
  color?: string
  style?: React.CSSProperties
  className?: string
}

// ─────────────────────────────────────────────
// コンポーネント
// ─────────────────────────────────────────────
export const Switch = ({
  checked,
  defaultChecked,
  onChange,
  disabled,
  label,
  color,
  style,
  className,
}: SwitchProps) => {
  return (
    <MantineSwitch
      checked={checked}
      defaultChecked={defaultChecked}
      onChange={(e) => onChange?.(e.currentTarget.checked)}
      disabled={disabled}
      label={label}
      style={
        {
          // Mantine v8: --switch-color = on 状態のトラック色
          // Figma: width=46px, height=26px
          '--switch-color': color ?? raundColors.primary.base,
          '--switch-width': '46px',
          '--switch-height': '26px',
          '--switch-thumb-size': '22px',
          ...style,
        } as React.CSSProperties
      }
      className={className}
      classNames={{
        track: styles.track,
        thumb: styles.thumb,
      }}
    />
  )
}
